var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"full_width_banner",style:({'--progress': 0})},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_c('h4',{attrs:{"data-highlightword":_vm.getWordsInFirstRow(_vm.title)},domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.parsedCta)?_c('primary-button',{class:_vm.cta_theme_colour,attrs:{"label":_vm.parsedCta.title,"link":_vm.parsedCta}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FullWidthBanner.vue